import * as Preact from "preact"

import "./DiceFace.less"

export default class DiceFace {
    render() {
        if(this.props.item == undefined) return

        let element = this.props.item.element

        // TODO: move this to a centralized function, called both in DiceFace and Dice and other places.
        let power = ((this.props.item.power || 0) + (this.props.unit.power || 0))
        if(this.props.item.powerboost instanceof Function) {
            power += this.props.item.powerboost({"stage": this.props.stage, "unit": this.props.unit, "item": this.props.item})
        }
        return (
            <div class="DiceFace" element={element} power={power / 10} index={this.props.index}>
                <div class="Icon" style={{
                    "background-image": this.props.item.icon && "url(" + this.props.item.icon + ")"
                }}/>
                <div class="SmallNumeral">
                    {power / 10}
                </div>
            </div>
        )
    }
}
